import { StepSequence } from 'new/form/model';

import { FieldTypes } from '../fields';

export const stepSequence: StepSequence<FieldTypes> = ['contractDetails', 'customerDataPage'];
